import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24031a68"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mdi mdi-filter has-text-white"
}
const _hoisted_2 = {
  key: 1,
  class: "elichens-avolta elichens-ch4-alert has-text-danger"
}
const _hoisted_3 = {
  key: 2,
  class: "mdi mdi-alert has-text-warning"
}
const _hoisted_4 = {
  key: 3,
  class: "elichens-avolta elichens-signal-0 has-text-white"
}
const _hoisted_5 = {
  key: 4,
  class: "mdi mdi-check-bold has-text-success"
}
const _hoisted_6 = {
  key: 5,
  class: "mdi mdi-filter has-text-white"
}
const _hoisted_7 = { class: "has-text-weight-bold" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { key: 3 }
const _hoisted_12 = { key: 4 }
const _hoisted_13 = {
  key: 0,
  class: "center h-100"
}
const _hoisted_14 = {
  key: 1,
  class: "center h-100"
}
const _hoisted_15 = { class: "is-size-5 is-italic" }
const _hoisted_16 = {
  key: 2,
  class: "avolta-list"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_input = _resolveComponent("n-input")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_tooltip = _resolveComponent("n-tooltip")!
  const _component_n_popselect = _resolveComponent("n-popselect")!
  const _component_n_spin = _resolveComponent("n-spin")!
  const _component_device_list_item = _resolveComponent("device-list-item")!
  const _component_WidgetBase = _resolveComponent("WidgetBase")!

  return (_openBlock(), _createBlock(_component_WidgetBase, {
    empty: !_ctx.stations,
    padding: true,
    class: "widget-avolta-list"
  }, {
    "header-left": _withCtx(() => [
      _createVNode(_component_n_input, {
        value: _ctx.search,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
        round: "",
        clearable: "",
        ref: "searchInput",
        placeholder: _ctx.$t('station_table.search.placeholder')
      }, null, 8 /* PROPS */, ["value", "placeholder"])
    ]),
    "header-right": _withCtx(() => [
      _createVNode(_component_n_popselect, {
        options: _ctx.options,
        "on-update:value": _ctx.toggleFilter
      }, {
        default: _withCtx(() => [
          _createVNode(_component_n_tooltip, { trigger: "hover" }, {
            trigger: _withCtx(() => [
              _createVNode(_component_n_button, {
                round: "",
                disabled: _ctx.loading,
                strong: "",
                secondary: "",
                type: ""
              }, {
                icon: _withCtx(() => [
                  (_ctx.filter === _ctx.DashboardFilterEnum.ALL)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1))
                    : (_ctx.filter === _ctx.DashboardFilterEnum.GAS)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_2))
                      : (_ctx.filter === _ctx.DashboardFilterEnum.TROUBLE)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3))
                        : (_ctx.filter === _ctx.DashboardFilterEnum.OFFLINE)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_4))
                          : (_ctx.filter === _ctx.DashboardFilterEnum.OK)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5))
                            : (_openBlock(), _createElementBlock("span", _hoisted_6))
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["disabled"])
            ]),
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('global.filter')) + ": ", 1 /* TEXT */),
              (_ctx.filter === _ctx.DashboardFilterEnum.ALL)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t('global.all')), 1 /* TEXT */))
                : (_ctx.filter === _ctx.DashboardFilterEnum.GAS)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t('avolta.alarm.ch4.short')), 1 /* TEXT */))
                  : (_ctx.filter === _ctx.DashboardFilterEnum.TROUBLE)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.$t('global.trouble')), 1 /* TEXT */))
                    : (_ctx.filter === _ctx.DashboardFilterEnum.OFFLINE)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.$t('global.network.offline')), 1 /* TEXT */))
                      : (_ctx.filter === _ctx.DashboardFilterEnum.OK)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$t('global.ok')), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["options", "on-update:value"])
    ]),
    default: _withCtx(() => [
      (!_ctx.stations)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createVNode(_component_n_spin, { size: "large" })
          ]))
        : (!_ctx.stations.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('station_list.no_station')), 1 /* TEXT */)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _hoisted_17,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filtered, (device) => {
                return (_openBlock(), _createBlock(_component_device_list_item, {
                  key: device.id,
                  device: device,
                  since: _ctx.since,
                  before: _ctx.before
                }, null, 8 /* PROPS */, ["device", "since", "before"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["empty"]))
}